import { Forbidden } from 'components/ErrorPage/ErrorPage';

function AccessPermission(props) {
  return !!props.access ? props.children : <Forbidden />;
}

export { AccessPermission };
